/* Universo Grocer: shopping features layered on the product cards.
   1. Quick view: a dialog with the case box, price, stock, ship-by and add to cart, rendered by sections/quick-view.liquid.
   2. Compare: pick up to 4 cards (kept in sessionStorage), a sticky tray, and a side-by-side table with the best value marked.
   Plain JavaScript, no dependencies. Adding to cart goes through the same form[data-add] path that universo.js handles. */
(function () {
  'use strict';
  if (window.__ufq) return;
  window.__ufq = true;

  var UB = window.UB || {};
  var ROUTES = UB.routes || {};
  var MAX = 4;
  var KEY = 'ufq-compare-v1';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var fmt = UB.moneyFormat || '${{amount}}';
    var n = (cents / 100).toFixed(2).split('.'), i = n[0], d = n[1];
    var withCommas = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      return k === 'amount_no_decimals' ? withCommas : k === 'amount_with_comma_separator' ? (i + '.' + d).replace('.', ',') : withCommas + '.' + d;
    });
  }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function num(v) { var n = parseFloat(v); return isNaN(n) ? null : n; }

  /* ---------- storage that never throws ---------- */
  var mem = null;
  var store = {
    get: function () {
      try { var v = sessionStorage.getItem(KEY); return v ? JSON.parse(v) : []; } catch (e) { return mem || []; }
    },
    set: function (v) {
      mem = v;
      try { sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode: memory only */ }
    }
  };

  /* ---------- icons (24px grid, 1.75px round stroke, currentColor) ---------- */
  var I_EYE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.75"/></svg>';
  var I_BOX = '<svg class="ufq-cb" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><rect x="4" y="4" width="16" height="16" rx="4" stroke="currentColor" stroke-width="1.75"/><path class="ufq-tick" d="M8 12.5l3 3 5-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var I_X = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  /* ---------- polite announcements for screen readers ---------- */
  var live = null;
  function announce(msg) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'sr';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 30);
  }
  /* the theme's own toast, for short messages that should be seen too */
  var toastT;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.innerHTML = '<span>' + esc(msg) + '</span>';
    t.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('on'); }, 3400);
  }

  /* ---------- scroll lock shared by both dialogs ---------- */
  var lock = { n: 0, prev: '' };
  function lockScroll(on) {
    var el = document.documentElement;
    if (on) { if (lock.n++ === 0) { lock.prev = el.style.overflow; el.style.overflow = 'hidden'; } }
    else if (lock.n > 0 && --lock.n === 0) { el.style.overflow = lock.prev; }
  }

  /* ---------- a small modal controller: focus trap, Esc, backdrop, return focus ---------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function focusables(root) {
    return $$(FOCUSABLE, root).filter(function (el) {
      if (el.getAttribute('aria-hidden') === 'true') return false;
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }
  function modal(ov, dlg, opts) {
    opts = opts || {};
    var trigger = null, isOpen = false;
    function onKey(e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); ctl.close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(dlg);
      if (!f.length) { e.preventDefault(); dlg.focus(); return; }
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || a === dlg)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
      else if (!dlg.contains(a)) { e.preventDefault(); first.focus(); }
    }
    function onFocusIn(e) {
      if (!isOpen || dlg.contains(e.target)) return;
      if (e.target.closest && e.target.closest('#toast')) return;
      var f = focusables(dlg); (f[0] || dlg).focus();
    }
    function onBackdrop(e) { if (e.target === ov) ctl.close(); }
    var ctl = {
      get isOpen() { return isOpen; },
      open: function (from) {
        if (isOpen) return;
        trigger = from || document.activeElement;
        ov.hidden = false;
        void ov.offsetWidth;
        ov.classList.add('on');
        isOpen = true;
        lockScroll(true);
        document.addEventListener('keydown', onKey, true);
        document.addEventListener('focusin', onFocusIn);
        ov.addEventListener('mousedown', onBackdrop);
        var first = opts.initial ? opts.initial() : null;
        (first || focusables(dlg)[0] || dlg).focus();
      },
      close: function () {
        if (!isOpen) return;
        isOpen = false;
        ov.classList.remove('on');
        ov.hidden = true;
        lockScroll(false);
        document.removeEventListener('keydown', onKey, true);
        document.removeEventListener('focusin', onFocusIn);
        ov.removeEventListener('mousedown', onBackdrop);
        var t = trigger; trigger = null;
        if (opts.onClose) opts.onClose();
        if (t && document.body.contains(t) && (t.offsetWidth || t.offsetHeight || t.getClientRects().length)) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
        else { var m = $('#main'); if (m) m.focus({ preventScroll: true }); }
      }
    };
    return ctl;
  }

  /* ---------- the cart, read only, to confirm an add worked ---------- */
  function cartMap() {
    return fetch((ROUTES.cart || '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { var m = {}; (c.items || []).forEach(function (i) { m[i.variant_id] = (m[i.variant_id] || 0) + i.quantity; }); return m; })
      .catch(function () { return {}; });
  }
  var known = Promise.resolve({});
  function refreshKnown() { known = cartMap(); return known; }
  /* universo.js marks the submit button aria-busy while it adds; when that clears, the add is done */
  function watchAdd(btn, variantId, onOk) {
    var was = false;
    var mo = new MutationObserver(function () {
      var busy = btn.getAttribute('aria-busy') === 'true';
      if (busy) { was = true; return; }
      if (!was) return;
      was = false;
      var before = known;
      before.then(function (b) {
        return cartMap().then(function (a) {
          known = Promise.resolve(a);
          var q = a[variantId] || 0;
          if (q > (b[variantId] || 0)) onOk(q);
        });
      });
    });
    mo.observe(btn, { attributes: true, attributeFilter: ['aria-busy'] });
    return mo;
  }
  function flash(btn, text) {
    if (btn._ufqHtml == null) btn._ufqHtml = btn.innerHTML;
    var keep = btn._ufqHtml;
    btn.classList.add('ok'); btn.textContent = text;
    clearTimeout(btn._ufqT);
    btn._ufqT = setTimeout(function () { btn.classList.remove('ok'); btn.innerHTML = keep; btn._ufqHtml = null; }, 1700);
  }

  /* ---------- reading a card ---------- */
  function cardInfo(card) {
    var br = $('.br .bn', card) || $('.br', card), nm = $('.nm', card), tg = $('.tg', card), im = $('.st img', card) || $('img', card);
    var pack = parseInt(card.dataset.pack, 10) || 1;
    var packLabel = '';
    if (tg) { var sp = tg.querySelector(':scope > span'); packLabel = sp ? sp.textContent.trim() : ''; }
    var src = im ? (im.getAttribute('data-src') || im.getAttribute('src') || '') : '';
    var diet = $('.dt', card);
    var link = $('a.nm', card) || $('a.st', card);
    return {
      handle: card.dataset.handle,
      variant: card.dataset.variant,
      brand: br ? br.textContent.trim() : '',
      name: nm ? nm.textContent.trim() : (card.getAttribute('aria-label') || ''),
      pack: pack,
      packLabel: packLabel,
      price: num(card.dataset.price) || 0,
      per: num(card.dataset.per),
      unit: card.dataset.unit || '',
      img: src,
      diet: diet ? diet.textContent.trim() : '',
      avail: !card.classList.contains('out'),
      url: link ? link.getAttribute('href') : '/products/' + card.dataset.handle
    };
  }
  function labelOf(it) { return (it.brand + ' ' + it.name).trim(); }

  /* =====================================================================
     QUICK VIEW
     ===================================================================== */
  var qv = null;
  var qvCache = {};

  function qvUrl(handle) {
    var base = (ROUTES.root || '/').replace(/\/?$/, '/');
    return base + 'products/' + encodeURIComponent(handle) + '?section_id=quick-view';
  }
  function fetchQV(handle) {
    if (qvCache[handle]) return qvCache[handle];
    var p = fetch(qvUrl(handle), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      return r.text();
    }).then(function (t) {
      var tpl = document.createElement('template'); tpl.innerHTML = t.trim();
      var node = tpl.content.querySelector('[data-qv-content]');
      if (!node || !node.getAttribute('data-handle')) throw new Error('empty');
      var im = node.querySelector('[data-qv-main]');
      if (im) { try { new Image().src = im.getAttribute('src'); } catch (e) { /* preload only */ } }
      return node.outerHTML;
    });
    qvCache[handle] = p;
    p.catch(function () { delete qvCache[handle]; });
    return p;
  }
  function prefetch(handle) {
    try {
      var c = navigator.connection;
      if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
    } catch (e) { /* ignore */ }
    if (!handle || qvCache[handle]) return;
    fetchQV(handle).catch(function () {});
  }

  function buildQV() {
    if (qv) return qv;
    var ov = document.createElement('div');
    ov.className = 'ufq-ov ufq-ov-qv'; ov.hidden = true;
    ov.innerHTML =
      '<div class="ufq-dlg ufq-dlg-qv" role="dialog" aria-modal="true" aria-labelledby="ufq-qv-title" tabindex="-1">' +
        '<button class="ufq-x" type="button" data-ufq-close aria-label="Close quick view">' + I_X + '</button>' +
        '<h2 class="sr" id="ufq-qv-title">Quick view</h2>' +
        '<div class="ufq-slot" data-ufq-slot></div>' +
      '</div>';
    document.body.appendChild(ov);
    var dlg = $('.ufq-dlg', ov);
    qv = { ov: ov, dlg: dlg, slot: $('[data-ufq-slot]', ov), title: $('#ufq-qv-title', ov), token: 0, mo: null, fallback: '' };
    qv.ctl = modal(ov, dlg, { onClose: function () { qv.token++; if (qv.mo) { qv.mo.disconnect(); qv.mo = null; } } });

    ov.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-ufq-close]')) { qv.ctl.close(); return; }
      var th = t.closest('[data-qv-thumb]');
      if (th) {
        var main = $('[data-qv-main]', qv.slot); if (!main) return;
        main.src = th.getAttribute('data-src');
        main.srcset = th.getAttribute('data-srcset') || '';
        $$('[data-qv-thumb]', qv.slot).forEach(function (b) { b.setAttribute('aria-pressed', String(b === th)); });
        return;
      }
      var q = t.closest('[data-qv-q]');
      if (q) { stepQty(+q.getAttribute('data-qv-q')); return; }
      if (t.closest('[data-qv-retry]')) { loadIntoQV(qv.handle, qv.label, qv.fallback); return; }
    });
    ov.addEventListener('input', function (e) { if (e.target.matches('[data-qv-qty]')) updTotal(); });
    ov.addEventListener('change', function (e) {
      if (e.target.matches('[data-qv-variant]')) pickVariant(e.target);
      if (e.target.matches('[data-qv-qty]')) { clampQty(); updTotal(); }
    });
    return qv;
  }

  function clampQty() {
    var i = $('[data-qv-qty]', qv.slot); if (!i) return 1;
    var max = parseInt(i.max, 10) || 99;
    var v = Math.max(1, Math.min(max, parseInt(i.value, 10) || 1));
    i.value = v; return v;
  }
  function stepQty(d) {
    var i = $('[data-qv-qty]', qv.slot); if (!i) return;
    var max = parseInt(i.max, 10) || 99;
    i.value = Math.max(1, Math.min(max, (parseInt(i.value, 10) || 1) + d));
    updTotal();
  }
  function updTotal() {
    var i = $('[data-qv-qty]', qv.slot), b = $('[data-qv-addbtn]', qv.slot), t = $('[data-qv-total]', qv.slot);
    if (!i || !b || !t) return;
    var q = Math.max(1, Math.min(parseInt(i.max, 10) || 99, parseInt(i.value, 10) || 1));
    t.textContent = money(+b.getAttribute('data-price') * q);
  }
  function pickVariant(sel) {
    var o = sel.options[sel.selectedIndex]; if (!o) return;
    var form = $('[data-qv-form]', qv.slot), btn = $('[data-qv-addbtn]', qv.slot);
    var set = function (s, v) { var el = $(s, qv.slot); if (el && v != null && v !== '') el.textContent = v; };
    set('[data-qv-price]', o.getAttribute('data-price-text'));
    set('[data-qv-each]', o.getAttribute('data-each-text'));
    set('[data-qv-per]', o.getAttribute('data-per-text'));
    if (form) {
      $('input[name=id]', form).value = o.value;
      var qty = $('[data-qv-qty]', form); qty.max = o.getAttribute('data-max') || 99;
      var ok = o.getAttribute('data-avail') === 'true';
      btn.disabled = !ok; btn.setAttribute('data-price', o.getAttribute('data-price'));
      var stock = $('[data-qv-stock]', qv.slot);
      if (stock) { stock.className = 'stock' + (ok ? '' : ' out'); stock.innerHTML = '<i></i>' + (ok ? 'In stock' : 'Out of stock right now.'); }
      clampQty(); updTotal(); rewatch(); noteFor(o.value);
    }
  }
  function rewatch() {
    if (qv.mo) { qv.mo.disconnect(); qv.mo = null; }
    var btn = $('[data-qv-addbtn]', qv.slot), form = $('[data-qv-form]', qv.slot);
    if (!btn || !form) return;
    qv.mo = watchAdd(btn, +$('input[name=id]', form).value, function (q) {
      flash(btn, 'Added to cart ✓');
      showNote(q);
      announce('Added to cart. ' + q + ' in your cart.');
    });
  }
  function showNote(q) {
    var n = $('[data-qv-note]', qv.slot); if (!n) return;
    n.innerHTML = q > 0 ? q + ' in your cart · <button type="button" class="ufq-link" data-cart-open>View cart</button>' : '';
  }
  function noteFor(id) {
    var slot = qv.slot;
    known.then(function (m) { if (qv.slot === slot && $('[data-qv-note]', slot)) showNote(m[id] || 0); });
  }
  function shipBy(root) {
    var el = $('[data-shipby]', root); if (!el) return;
    try {
      var day = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'short' });
      var out = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'short', month: 'short', day: 'numeric' });
      var d = new Date(), n = 0;
      while (n < 2) { d = new Date(d.getTime() + 864e5); var w = day.format(d); if (w !== 'Sat' && w !== 'Sun') n++; }
      el.querySelector('b').textContent = out.format(d); el.hidden = false;
    } catch (e) { /* the line stays hidden */ }
  }

  var SKELETON =
    '<div class="ufq-body ufq-skel" aria-hidden="true">' +
      '<div class="ufq-media"><div class="ufq-stage"><span class="ufq-sk" style="width:58%;height:74%;border-radius:14px"></span></div></div>' +
      '<div class="ufq-info"><span class="ufq-sk" style="width:30%;height:14px"></span><span class="ufq-sk" style="width:86%;height:34px"></span>' +
      '<span class="ufq-sk" style="width:100%;height:76px;border-radius:16px"></span><span class="ufq-sk" style="width:46%;height:44px"></span>' +
      '<span class="ufq-sk" style="width:38%;height:16px"></span><span class="ufq-sk" style="width:100%;height:56px;border-radius:14px"></span></div>' +
    '</div><p class="sr" role="status">Loading product details</p>';

  function loadIntoQV(handle, label, fallback) {
    var tok = ++qv.token;
    qv.slot.innerHTML = SKELETON;
    qv.slot.setAttribute('aria-busy', 'true');
    fetchQV(handle).then(function (h) {
      if (tok !== qv.token || !qv.ctl.isOpen) return;
      qv.slot.innerHTML = h;
      qv.slot.removeAttribute('aria-busy');
      shipBy(qv.slot);
      updTotal();
      rewatch();
      var vid = $('input[name=id]', qv.slot);
      refreshKnown();
      if (vid) noteFor(vid.value);
    }).catch(function () {
      if (tok !== qv.token || !qv.ctl.isOpen) return;
      qv.slot.removeAttribute('aria-busy');
      qv.slot.innerHTML =
        '<div class="ufq-err" role="alert"><h3>We couldn’t open the quick view</h3>' +
        '<p>Check your connection and try again, or go straight to the product page.</p>' +
        '<div class="ufq-err-a"><button class="ufq-add" type="button" data-qv-retry>Try again</button>' +
        '<a class="ufq-add ghost" href="' + esc(fallback) + '">View full details</a></div></div>';
    });
  }
  function openQV(card, trigger) {
    var it = cardInfo(card);
    buildQV();
    qv.handle = it.handle; qv.label = labelOf(it); qv.fallback = it.url;
    qv.title.textContent = 'Quick view: ' + qv.label;
    qv.slot.innerHTML = SKELETON;
    qv.ctl.open(trigger);
    refreshKnown();
    loadIntoQV(it.handle, qv.label, it.url);
  }

  /* =====================================================================
     COMPARE
     ===================================================================== */
  var items = store.get().filter(function (i) { return i && i.handle; }).slice(0, MAX);
  var tray = null, cmp = null;

  function has(handle) { return items.some(function (i) { return i.handle === handle; }); }
  function persist() { store.set(items); }

  function toggleCompare(card) {
    var it = cardInfo(card), lbl = labelOf(it);
    if (has(it.handle)) {
      items = items.filter(function (i) { return i.handle !== it.handle; });
      announce(lbl + ' removed from compare. ' + items.length + ' of ' + MAX + ' selected.');
    } else {
      if (items.length >= MAX) {
        var msg = 'You can compare up to ' + MAX + ' products. Remove one to add another.';
        toast(msg); announce(msg); return;
      }
      items.push(it);
      announce(lbl + ' added to compare. ' + items.length + ' of ' + MAX + ' selected.' + (items.length < 2 ? ' Pick one more to compare.' : ''));
    }
    persist(); renderCompare();
  }
  function removeCompare(handle) {
    var it = items.filter(function (i) { return i.handle === handle; })[0];
    items = items.filter(function (i) { return i.handle !== handle; });
    persist(); renderCompare();
    if (it) announce(labelOf(it) + ' removed from compare. ' + items.length + ' of ' + MAX + ' selected.');
  }
  function clearCompare() {
    items = []; persist(); renderCompare();
    announce('Compare list cleared.');
  }

  function syncCards(root) {
    $$('.ufq-cmp', root).forEach(function (b) {
      var card = b.closest('[data-card]'); if (!card) return;
      var on = has(card.dataset.handle);
      b.setAttribute('aria-pressed', String(on));
      card.classList.toggle('ufq-picked', on);
      b.classList.toggle('ufq-capped', !on && items.length >= MAX);
    });
  }

  function buildTray() {
    if (tray) return tray;
    var el = document.createElement('div');
    el.className = 'ufq-tray'; el.hidden = true;
    el.setAttribute('role', 'region'); el.setAttribute('aria-label', 'Compare products');
    el.innerHTML =
      '<div class="ufq-tray-in">' +
        '<ul class="ufq-tl" data-ufq-tl></ul>' +
        '<p class="ufq-tc" data-ufq-tc></p>' +
        '<div class="ufq-ta">' +
          '<button class="ufq-go" type="button" data-ufq-open>Compare</button>' +
          '<button class="ufq-clr" type="button" data-ufq-clear>Clear</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    tray = { el: el, list: $('[data-ufq-tl]', el), count: $('[data-ufq-tc]', el), go: $('[data-ufq-open]', el) };
    el.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-ufq-rm]');
      if (rm) {
        var handle = rm.getAttribute('data-ufq-rm');
        var idx = items.map(function (i) { return i.handle; }).indexOf(handle);
        removeCompare(handle);
        // keep keyboard focus in the tray
        var next = $$('[data-ufq-rm]', tray.el)[Math.min(idx, items.length - 1)];
        if (next) next.focus(); else if (items.length) tray.go.focus(); else { var mn = $('#main'); if (mn) mn.focus({ preventScroll: true }); }
        return;
      }
      if (e.target.closest('[data-ufq-clear]')) { clearCompare(); return; }
      if (e.target.closest('[data-ufq-open]')) {
        if (items.length < 2) { var m = 'Pick at least 2 products to compare.'; toast(m); announce(m); return; }
        openCompare(e.target.closest('[data-ufq-open]'));
      }
    });
    return tray;
  }

  function renderTray() {
    if (!items.length) {
      if (tray) tray.el.hidden = true;
      document.body.classList.remove('ufq-has-tray');
      return;
    }
    buildTray();
    var lis = items.map(function (i) {
      return '<li class="ufq-tt">' +
        '<a class="ufq-th" href="' + esc(i.url) + '" title="' + esc(labelOf(i)) + '">' + (i.img ? '<img src="' + esc(img(i.img, 96)) + '" alt="' + esc(labelOf(i)) + '" width="44" height="44">' : '<span>' + esc((i.brand || '?').charAt(0)) + '</span>') + '</a>' +
        '<button class="ufq-rm" type="button" data-ufq-rm="' + esc(i.handle) + '" aria-label="Remove ' + esc(labelOf(i)) + ' from compare">' + I_X + '</button>' +
      '</li>';
    });
    for (var k = items.length; k < MAX; k++) lis.push('<li class="ufq-tt ufq-empty" aria-hidden="true"></li>');
    tray.list.innerHTML = lis.join('');
    tray.count.innerHTML = '<b class="num">' + items.length + '</b> of ' + MAX + ' selected' + (items.length < 2 ? '<span class="ufq-hint"> · add one more</span>' : '');
    tray.go.setAttribute('aria-disabled', items.length < 2 ? 'true' : 'false');
    tray.go.textContent = 'Compare';
    tray.el.hidden = false;
    document.body.classList.add('ufq-has-tray');
  }

  function renderCompare() {
    renderTray();
    syncCards(document);
    if (cmp && cmp.ctl.isOpen) {
      if (items.length < 2) cmp.ctl.close(); else renderTable();
    }
  }

  /* ---- the compare dialog ---- */
  function buildCompare() {
    if (cmp) return cmp;
    var ov = document.createElement('div');
    ov.className = 'ufq-ov ufq-ov-cmp'; ov.hidden = true;
    ov.innerHTML =
      '<div class="ufq-dlg ufq-dlg-cmp" role="dialog" aria-modal="true" aria-labelledby="ufq-cmp-title" aria-describedby="ufq-cmp-sub" tabindex="-1">' +
        '<div class="ufq-cmp-head">' +
          '<div><span class="eyebrow">Side by side</span><h2 id="ufq-cmp-title">Compare products</h2><p class="ufq-sub" id="ufq-cmp-sub"></p></div>' +
          '<button class="ufq-x ufq-x-flow" type="button" data-ufq-close aria-label="Close comparison">' + I_X + '</button>' +
        '</div>' +
        '<div class="ufq-tw" data-ufq-tw role="region" aria-label="Comparison table, scrolls sideways on small screens" tabindex="0"></div>' +
        '<p class="ufq-foot" data-ufq-foot></p>' +
      '</div>';
    document.body.appendChild(ov);
    var dlg = $('.ufq-dlg', ov);
    cmp = { ov: ov, dlg: dlg, wrap: $('[data-ufq-tw]', ov), sub: $('#ufq-cmp-sub', ov), foot: $('[data-ufq-foot]', ov), mos: [] };
    cmp.ctl = modal(ov, dlg, { onClose: function () { cmp.mos.forEach(function (m) { m.disconnect(); }); cmp.mos = []; } });
    ov.addEventListener('click', function (e) {
      if (e.target.closest('[data-ufq-close]')) { cmp.ctl.close(); return; }
      var rm = e.target.closest('[data-ufq-trm]');
      if (rm) {
        var handle = rm.getAttribute('data-ufq-trm');
        var idx = items.map(function (i) { return i.handle; }).indexOf(handle);
        removeCompare(handle);
        if (cmp.ctl.isOpen) {
          var btns = $$('[data-ufq-trm]', cmp.ov);
          (btns[Math.min(idx, btns.length - 1)] || cmp.dlg).focus();
        }
        return;
      }
    });
    return cmp;
  }

  function bestFlags(vals, keys) {
    var groups = {}, out = vals.map(function () { return false; });
    vals.forEach(function (v, i) {
      if (v == null || isNaN(v)) return;
      var k = keys ? keys[i] : '_';
      (groups[k] = groups[k] || []).push(i);
    });
    Object.keys(groups).forEach(function (k) {
      var idx = groups[k]; if (idx.length < 2) return;
      var vs = idx.map(function (i) { return vals[i]; });
      var min = Math.min.apply(null, vs), max = Math.max.apply(null, vs);
      if (min === max) return;
      idx.forEach(function (i) { if (vals[i] === min) out[i] = true; });
    });
    return out;
  }

  function renderTable() {
    var n = items.length;
    var eachV = items.map(function (i) { return i.price / (i.pack || 1); });
    var priceV = items.map(function (i) { return i.price; });
    var perV = items.map(function (i) { return i.per != null && i.unit ? i.per : null; });
    var perK = items.map(function (i) { return i.unit; });
    var bPrice = bestFlags(priceV), bEach = bestFlags(eachV), bPer = bestFlags(perV, perK);
    var units = {}; perK.forEach(function (u, i) { if (perV[i] != null) units[u] = 1; });
    var mixed = Object.keys(units).length > 1;
    var hasDiet = items.some(function (i) { return i.diet; });

    function cell(html, best, label, cls) {
      return '<td class="' + (cls || '') + (best ? ' is-best' : '') + '">' + html + (best ? '<span class="ufq-badge">' + label + '</span>' : '') + '</td>';
    }
    var head = '<tr><th scope="col" class="ufq-corner"><span class="sr">Feature</span></th>' + items.map(function (i) {
      return '<th scope="col" class="ufq-thead"><a class="ufq-ph" href="' + esc(i.url) + '">' +
        (i.img ? '<img src="' + esc(img(i.img, 240)) + '" alt="" width="96" height="96">' : '<span class="ufq-noimg">' + esc((i.brand || '?').charAt(0)) + '</span>') +
        '<span class="ufq-pb">' + esc(i.brand) + '</span><span class="ufq-pn">' + esc(i.name) + '</span></a></th>';
    }).join('') + '</tr>';

    var rows = [];
    rows.push('<tr><th scope="row">Case size</th>' + items.map(function (i) {
      var txt = i.pack > 1 ? 'Case of ' + i.pack : '';
      // the card says "Case of 6 · 10 oz each": keep only the part after the case count
      var sub = i.packLabel && i.packLabel !== txt ? i.packLabel.replace(txt + ' · ', '') : '';
      return '<td class="num"><b>' + esc(txt || i.packLabel || 'Single item') + '</b>' + (txt && sub ? '<span class="ufq-s">' + esc(sub) + '</span>' : '') + '</td>';
    }).join('') + '</tr>');
    rows.push('<tr><th scope="row">Case price</th>' + items.map(function (i, k) { return cell('<b class="num">' + money(i.price) + '</b>', bPrice[k], 'Lowest price'); }).join('') + '</tr>');
    rows.push('<tr><th scope="row">Price per item</th>' + items.map(function (i, k) { return cell('<b class="num">' + money(Math.round(eachV[k])) + '</b>', bEach[k], 'Lowest per item'); }).join('') + '</tr>');
    rows.push('<tr><th scope="row">Price per oz or unit</th>' + items.map(function (i, k) {
      if (perV[k] == null) return '<td class="ufq-na"><span aria-hidden="true">–</span><span class="sr">Not available</span></td>';
      return cell('<b class="num">' + money(Math.round(perV[k])) + '</b><span class="ufq-s"> per ' + esc(i.unit) + '</span>', bPer[k], 'Best value');
    }).join('') + '</tr>');
    if (hasDiet) rows.push('<tr><th scope="row">Good to know</th>' + items.map(function (i) { return '<td>' + (i.diet ? '<span class="ufq-diet">' + esc(i.diet) + '</span>' : '<span class="ufq-na"><span aria-hidden="true">–</span><span class="sr">None listed</span></span>') + '</td>'; }).join('') + '</tr>');
    rows.push('<tr><th scope="row">Availability</th>' + items.map(function (i) {
      return '<td>' + (i.avail ? '<span class="ufq-in"><i></i>In stock</span>' : '<span class="ufq-oos"><i></i>Sold out</span>') + '</td>';
    }).join('') + '</tr>');
    var cartAdd = ROUTES.cartAdd || '/cart/add';
    rows.push('<tr class="ufq-acts"><th scope="row">Order</th>' + items.map(function (i) {
      var lbl = esc(labelOf(i));
      var add = i.avail && i.variant
        ? '<form method="post" action="' + esc(cartAdd) + '" data-add data-ufq-form="' + esc(i.variant) + '"><input type="hidden" name="id" value="' + esc(i.variant) + '"><input type="hidden" name="quantity" value="1"><button class="ufq-add" type="submit" aria-label="Add ' + lbl + ' to cart">Add to cart</button></form>'
        : '<a class="ufq-add ghost" href="' + esc(i.url) + '#notify" aria-label="Get notified when ' + lbl + ' is back">Notify me</a>';
      return '<td>' + add + '<button class="ufq-rmb" type="button" data-ufq-trm="' + esc(i.handle) + '" aria-label="Remove ' + lbl + ' from compare">Remove</button></td>';
    }).join('') + '</tr>');

    cmp.wrap.style.setProperty('--ufq-cols', n);
    cmp.wrap.innerHTML =
      '<table class="ufq-table"><caption class="sr">Comparison of ' + n + ' products. Rows are features, columns are products. The best value in each row is marked.</caption>' +
      '<thead>' + head + '</thead><tbody>' + rows.join('') + '</tbody></table>';
    cmp.sub.textContent = n + ' products side by side. The best value in each row is marked.';
    cmp.foot.textContent = mixed
      ? 'Best value compares price per unit only between products sold in the same unit (oz with oz, lb with lb).'
      : 'Best value is the lowest price per unit among products measured the same way.';

    cmp.mos.forEach(function (m) { m.disconnect(); }); cmp.mos = [];
    known = cartMap();
    $$('[data-ufq-form]', cmp.wrap).forEach(function (f) {
      var btn = $('button[type=submit]', f), id = f.getAttribute('data-ufq-form');
      var it = items.filter(function (x) { return String(x.variant) === id; })[0];
      cmp.mos.push(watchAdd(btn, +id, function (q) {
        flash(btn, 'Added ✓');
        announce((it ? labelOf(it) : 'Item') + ' added to cart. ' + q + ' in your cart.');
      }));
    });
  }

  function openCompare(trigger) {
    if (items.length < 2) return;
    buildCompare();
    renderTable();
    cmp.ctl.open(trigger);
  }

  /* =====================================================================
     BINDING TO CARDS (existing and added later)
     ===================================================================== */
  function bind(card) {
    if (card.hasAttribute('data-ufq')) return;
    if (!card.dataset.handle) return;
    if (card.closest('[aria-hidden="true"]')) return;
    card.setAttribute('data-ufq', '');
    var it = cardInfo(card), lbl = labelOf(it);

    var st = $('.st', card);
    var layer = document.createElement('div');
    layer.className = 'ufq-layer';
    layer.innerHTML = '<button class="ufq-qv" type="button" aria-haspopup="dialog" aria-label="Quick view: ' + esc(lbl) + '">' + I_EYE + '<span class="ufq-qvt">Quick view</span></button>';
    if (st && st.parentNode === card) card.insertBefore(layer, st.nextSibling); else card.appendChild(layer);

    var b = document.createElement('button');
    b.className = 'ufq-cmp'; b.type = 'button';
    b.setAttribute('aria-pressed', String(has(it.handle)));
    b.setAttribute('aria-label', 'Compare ' + lbl); b.title = 'Compare';
    b.innerHTML = I_BOX + '<span>Compare</span>';
    card.appendChild(b);
    if (has(it.handle)) card.classList.add('ufq-picked');
  }
  function scan(root) {
    $$('article.it[data-card]:not([data-ufq])', root || document).forEach(bind);
    syncCards(root || document);
  }

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var q = t.closest('.ufq-qv');
    if (q) { var c = q.closest('[data-card]'); if (c) { e.preventDefault(); openQV(c, q); } return; }
    var b = t.closest('.ufq-cmp');
    if (b) { var cd = b.closest('[data-card]'); if (cd) { e.preventDefault(); toggleCompare(cd); } return; }
    // the theme's "View cart" opens its own drawer; get out of its way first
    if (t.closest('[data-cart-open]')) {
      if (qv && qv.ctl.isOpen) qv.ctl.close();
      if (cmp && cmp.ctl.isOpen) cmp.ctl.close();
    }
  }, true);

  /* prefetch the quick view while the pointer rests on a card, or a finger lands on its button */
  var hoverT = null, hoverCard = null;
  document.addEventListener('mouseover', function (e) {
    var c = e.target.closest && e.target.closest('article.it[data-ufq]');
    if (!c || c === hoverCard) return;
    hoverCard = c; clearTimeout(hoverT);
    hoverT = setTimeout(function () { prefetch(c.dataset.handle); }, 120);
  });
  document.addEventListener('mouseout', function (e) {
    var c = e.target.closest && e.target.closest('article.it[data-ufq]');
    if (c && c === hoverCard && !(e.relatedTarget && c.contains(e.relatedTarget))) { hoverCard = null; clearTimeout(hoverT); }
  });
  document.addEventListener('focusin', function (e) {
    var b = e.target.closest && e.target.closest('.ufq-qv'); if (!b) return;
    var c = b.closest('[data-card]'); if (c) prefetch(c.dataset.handle);
  });
  document.addEventListener('touchstart', function (e) {
    var b = e.target.closest && e.target.closest('.ufq-qv'); if (!b) return;
    var c = b.closest('[data-card]'); if (c) prefetch(c.dataset.handle);
  }, { passive: true });

  /* cards can arrive at any time: rows, "show more", tabs, saved drawer, recently viewed */
  var queued = false;
  function queueScan(muts) {
    if (queued) return;
    var relevant = muts.some(function (m) {
      if (!m.addedNodes.length) return false;
      var t = m.target;
      return !(t && t.closest && t.closest('.ufq-ov, .ufq-tray'));
    });
    if (!relevant) return;
    queued = true;
    setTimeout(function () { queued = false; scan(); }, 50);
  }

  function init() {
    try {
      scan();
      renderCompare();
      if ('MutationObserver' in window) new MutationObserver(queueScan).observe(document.body, { childList: true, subtree: true });
      // tabs of another window can change nothing here (sessionStorage is per tab), but bfcache restores can
      window.addEventListener('pageshow', function (e) { if (e.persisted) { items = store.get().slice(0, MAX); scan(); renderCompare(); } });
    } catch (err) {
      if (window.console && console.warn) console.warn('universo-features:', err);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
